<template>
	<div class="investor-relation">
		<img
			class="banner"
			src="@/assets/images/investorRelation/investor_relations.jpg"
			alt=""
		/>
		<nav-component
			:navs="navs"
			@on-switch="switchNav"
			:active-index="navIndex"
            :active-child-index="childIndex"
		></nav-component>
		<router-view :key="key" />
		<to-top></to-top>
	</div>
</template>

<script>
import { navs } from "./config";
import navComponent from "@/components/navs";
import toTop from '@/components/to-top'

export default {
	name: "investorRelations",
	components: {
		navComponent,
		toTop
	},
	data() {
		return {
			navs,
			navIndex: -1,
            childIndex: -1
		};
	},
	created() {
        this.navs.forEach((item, index) => {
            let inner = -1
            if(item.children && item.children.length) {
                inner = item.children.findIndex(child => {
                    return this.key.indexOf(child.path) > -1;
                })
                if(inner > -1) {
                    this.navIndex = index
                    this.childIndex = inner
                }
            } else if(this.key.indexOf(item.path) > -1){
                this.navIndex = index
            }
        })
	},
	computed: {
		key() {
			return this.$route.fullPath;
		}
	},
	methods: {
		switchNav(data) {
			const item = data.child ? data.child : data.item
			if (this.key.indexOf(item.path) > 0) return;
			this.$router.push({
				path: item.path
			});
			this.navIndex = this.navs.findIndex(item => {
				return this.key.indexOf(item.path) > -1;
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.investor-relation {
	.banner {
		width: 100%;
		display: block;
	}
	>>> .navs {
		.nav-item {
			font-size: 0.3rem;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/investorRelations/index.vue